import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tenant-status-icon',
  standalone: false,
  templateUrl: './tenant-status-icon.component.html',
  styleUrl: './tenant-status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantStatusIconComponent {
  public selected = input<boolean>(false);
}
